import { render, staticRenderFns } from "./videoMember.vue?vue&type=template&id=2ba08644&scoped=true&"
import script from "./videoMember.vue?vue&type=script&lang=js&"
export * from "./videoMember.vue?vue&type=script&lang=js&"
import style0 from "./videoMember.vue?vue&type=style&index=0&id=2ba08644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba08644",
  null
  
)

export default component.exports